<template>
  <fragment>
    <slot v-if="currentUserIsAdministrator" />
  </fragment>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: 'AdminOnly',
  props: {
    redirectOnNotAuthorized: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (!this.currentUserIsAdministrator && this.redirectOnNotAuthorized) {
      this.$router.push({
        path: '/zeiten',
        query: '',
      });
    }
  },
  watch: {
  },
  computed: mapGetters(['currentUserIsAdministrator']),
  methods: {
  },
  data: () => ({
  }),
};
</script>
